/* unplugin-vue-components disabled */import script from "./sysPermMgmt.vue?vue&type=script&setup=true&lang=js"
export * from "./sysPermMgmt.vue?vue&type=script&setup=true&lang=js"

import "./sysPermMgmt.vue?vue&type=style&index=0&id=9e7ce628&lang=less&scoped=true"

import exportComponent from "/Users/kummy/Documents/xsyx/grape-setting/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e7ce628"]])

export default __exports__